import React from "react";
import { CheckRow, MainTitle } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import { SeparatorLine } from "app/components/common/SeparatorLine";
import { useDispatch, useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import {
  changeUserInfo,
  changeUserLanguage,
} from "@microdoing/shared/services/profileSettings/actions";

interface IProps {}

const ProfileLanguage = ({}: IProps) => {
  const settingLanguage = useSelector(getLanguage);

  const dispatch = useDispatch();

  const onChangeLanguage = language => () => {
    dispatch(changeUserLanguage(language));
    dispatch(changeUserInfo({ language }));
  };

  return (
    <AnimatedBox style={styles.mainBox}>
      <MainTitle variant="l7-bold" marginBottom="s" marginLeft="xm">
        {i18n.t("language-title")}
      </MainTitle>
      <CheckRow
        text={i18n.t("french")}
        isSelected={settingLanguage === "fr"}
        onPress={onChangeLanguage("fr")}
        emojiText={"🇫🇷"}
      />
      <CheckRow
        text={i18n.t("english")}
        isSelected={settingLanguage === "en"}
        onPress={onChangeLanguage("en")}
        emojiText={"🇬🇧"}
      />
    </AnimatedBox>
  );
};

const styles = {
  mainBox: {
    alignSelf: "center",
    width: "100%",
    marginBottom: 15,
    paddingHorizontal: 0,
  },
};

export default ProfileLanguage;
